import { __assign, __extends } from "tslib";
import React from 'react';
import { WrapperItem } from '../../components/wrapper-item';
import { Section } from '../../components/section';
import { Column } from '../../components/column';
import { shorthand } from '../../utils/css-utils';
import { BdiWrapper } from '../../components/bdi-wrapper';
import { Button } from './button';
var SectionButton = /** @class */ (function (_super) {
    __extends(SectionButton, _super);
    function SectionButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionButton.prototype.render = function () {
        var _a;
        var _b = this.props, section = _b.section, cssClass = _b.cssClass, isRtl = _b.isRtl, columnCssClass = _b.columnCssClass;
        var button = section.button;
        var direction = isRtl ? 'rtl' : 'ltr';
        return (React.createElement(WrapperItem, null,
            React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(section.outerPadding), textAlign: button.align },
                React.createElement(Column, { cssClass: columnCssClass, direction: direction, padding: shorthand(section.innerPadding) },
                    React.createElement(Button, __assign({ align: "center" }, button, { padding: "0", textDecoration: button.textDecoration, fontStyle: button.fontStyle, hasRelAtr: true, minWidth: section.minWidth, maxWidth: section.maxWidth }),
                        React.createElement(BdiWrapper, { text: ((_a = button.text) === null || _a === void 0 ? void 0 : _a.trim()) ? button.text : '\u00A0' }))))));
    };
    return SectionButton;
}(React.Component));
export { SectionButton };
//# sourceMappingURL=section-button.js.map